import React, { useState, useRef, useEffect } from "react";

export default function OrderNote() {
    const [note, setNote] = useState("âsdasd");
    const textareaRef = useRef<HTMLTextAreaElement>(null);

    // auto resize giống UI gốc
    useEffect(() => {
        const el = textareaRef.current;
        if (!el) return;

        el.style.height = "auto";
        el.style.height = el.scrollHeight + "px";
    }, [note]);

    return (
        <div className="MuiPaper-root styles_colNote__OTG6C MuiPaper-elevation0 MuiPaper-rounded">
            <h4>Ghi chú</h4>

            <p>
                Trường hợp không tìm được thuốc mong muốn, Quý khách vui lòng điền yêu cầu bên dưới.
                Chúng tôi sẽ liên hệ mua thuốc và báo giá sớm nhất có thể.
            </p>

            {/* textarea chính */}
            <textarea
                rows={1}
                name="note"
                className="styles_text_area__ay6bm"
                aria-label="Ghi chú của khách hàng"
                placeholder="Ghi chú..."
                ref={textareaRef}
                value={note}
                onChange={(e) => setNote(e.target.value)}
                style={{
                    height: "111px",
                    overflow: "hidden"
                }}
            />
        </div>
    );
}
